import React from 'react';
import { Query } from '@apollo/client/react/components';

import env from 'bench-environment';
import { LedgerQuery } from './queries';
import LedgerList from './LedgerList';

export const emptyLedger = {
  id: '0',
  code: '0000',
  categoryId: 0,
  currencyId: '',
  clientId: '',
  role: '',
  name: 'Unknown Ledger',
  accountType: '',
  canBeEdited: false,
  canInfoBeEdited: false,
  canDeleteCauseConflict: false,
  canBeHidden: false,
  canBeDeleted: false,
  canTransfer: false,
  order: 0,
  version: 5,
  isAddOn: false,
  details: '',
  statementDayOfMonth: null,
  active: false,
  internalNotes: [],
  accountSettings: {
    collectionMethod: null,
    optimizationStatus: null,
    volume: '',
    dateActive: '',
    dateInactive: '',
  },
};

const getLedgerByCode = (ledgerList, code) =>
  ledgerList.find(ledger => ledger.code === code) || emptyLedger;
const getLedgerById = (ledgerList, id) =>
  ledgerList.find(ledger => ledger.id === id) || emptyLedger;

export const getApplicableLedgerAccounts = (
  ledgerAccounts: Record<string, unknown>[],
  ledgerCodes: Array<string> = [],
  ledgerIds: Array<string> = [],
) => {
  const ledgerAccountsByCode = ledgerCodes.map(code => getLedgerByCode(ledgerAccounts, code));

  const ledgerAccountsById = ledgerIds.map(id => getLedgerById(ledgerAccounts, id));

  return [...ledgerAccountsByCode, ...ledgerAccountsById];
};

type LedgerAccountLinkContainerProps = {
  ledgerCodes: Array<string>;
  ledgerIds: Array<string>;
  clientId: string;
  startDate: string;
  endDate: string;
  onSidebarToggle: (data: { journalEntryId?: string; ledgerId?: string }) => void;
};

const LedgerAccountLinkContainer = ({
  ledgerCodes,
  ledgerIds,
  clientId,
  startDate,
  endDate,
  onSidebarToggle,
}: LedgerAccountLinkContainerProps) => (
  <Query query={LedgerQuery} variables={{ clientId }}>
    {({ loading, error, data }: any) => {
      if (loading || error) {
        return null;
      }

      const ledgerAccounts = data?.ledgerAccounts;

      const applicableLedgerAccounts = getApplicableLedgerAccounts(
        ledgerAccounts,
        ledgerCodes,
        ledgerIds,
      );

      const balanceSheetLedgers = applicableLedgerAccounts.filter(
        ledger => ledger && ledger.categoryId < 6,
      );

      const incomeStatementLedgers = applicableLedgerAccounts.filter(
        ledger => ledger && ledger.categoryId >= 6,
      );

      const balanceSheetBaseUrl = `${env.location.bkTools}/${clientId}/balance-sheet/review`;
      const incomeStatementBaseUrl = `${env.location.bkTools}/${clientId}/income-statement/review`;
      const urlSuffix = `/start/${startDate}/end/${endDate}`;

      return (
        <div>
          {balanceSheetLedgers && (
            <LedgerList
              ledgerAccounts={balanceSheetLedgers}
              baseUrl={balanceSheetBaseUrl}
              urlSuffix={urlSuffix}
              onSidebarToggle={onSidebarToggle}
            />
          )}
          {incomeStatementLedgers && (
            <LedgerList
              ledgerAccounts={incomeStatementLedgers}
              baseUrl={incomeStatementBaseUrl}
              urlSuffix={urlSuffix}
              onSidebarToggle={onSidebarToggle}
            />
          )}
        </div>
      );
    }}
  </Query>
);

LedgerAccountLinkContainer.defaultProps = {
  ledgerCodes: [],
  ledgerIds: [],
};

export default LedgerAccountLinkContainer;
